import { css } from "@emotion/react";
import { Theme } from "@mui/material";

export const menuLinkNodeStyles = {
  highlightedNodeStyles: (theme: Theme) =>
    css({
      ".MuiTypography-root": {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(14),
      },
    }),
  link: (theme: Theme) =>
    css({
      height: 48,
      "&:visited": {
        color: theme.palette.text.primary,
      },
      "&:focus-visible, &:hover": {
        textDecoration: "underline",
        background: "unset",
      },
    }),
  dividerMargins: css({
    marginLeft: "1rem",
    marginRight: "1rem",
  }),
  secondLevelNodeText: (theme: Theme) =>
    css({
      ".MuiTypography-root": {
        fontWeight: theme.typography.fontWeightLight,
      },
    }),
};
